import { Button, Flex, Box, Select, Text } from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import React from "react";
import { PAGINATION_STYLES } from "./Pagination.styles";

export default function Pagination({
  pagination= true,
  handlePageChange,
  currentPage,
  totalPages,
}) {
  return (
    <Flex justifyContent={"flex-end"}>
      {pagination && (
        <Flex {...PAGINATION_STYLES.container}>
          <Button
            {...PAGINATION_STYLES.button}
            onClick={() => handlePageChange(Number(currentPage - 1))}
            isDisabled={currentPage === 1}
            leftIcon={<ChevronLeftIcon boxSize={4} />}
          >
            Previous
          </Button>

          <Box {...PAGINATION_STYLES.pageContainer}>
            <Text {...PAGINATION_STYLES.text.page}>
              Page
            </Text>
            <Select
              {...PAGINATION_STYLES.select}
              value={currentPage}
              onChange={(e) => handlePageChange(Number(e.target.value))}
            >
              {totalPages && Array.from({ length: totalPages }, (_, i) => (
                <option key={i + 1} value={i + 1}>
                  {i + 1}
                </option>
              ))}
            </Select>
            <Text {...PAGINATION_STYLES.text.total}>
              of {totalPages}
            </Text>
          </Box>

          <Button
            {...PAGINATION_STYLES.button}
            onClick={() => handlePageChange(Number(currentPage + 1))}
            isDisabled={currentPage === totalPages}
            rightIcon={<ChevronRightIcon boxSize={4} />}
          >
            Next
          </Button>
        </Flex>
      )}
    </Flex>
  );
}
